/************************************
MODULE:         FORM
WHAT IT DOES:   Form elements creation, functioning and form validation
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var isParsleyInited = false;
    var gaTracking = require('app.gatracking');
    var isIntersectionObserverAvailable = ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype);

    function init() {
        var $html = $('html');
        initFormsAndElements();
        $(window).on('forms:reinit', initFormsAndElements);
        $(window).on('forms:submitQuote', ajaxSubmitAndRedirectTo);
        $(window).bind("pageshow", unloadForms);
    }

    function unloadForms() {
        var customForms = $('.js-custom-form');
        customForms.removeClass('js-disabled');
    }

    function initFormsAndElements() {
        initSelects();
        initCustomSelect();
        initDatePickers();
        initTextarea();
        initSpinbox();
        initCorrespondence();
        initDefault();
        initCustomForms();
        initSimpleForms();
        initFocus();
    }

    function initFocus() {
        var focusForms = $('.js-focus').not('.js-focus-inited');
        if (!focusForms.length)
            return;

        focusForms.addClass('js-focus-inited');

        for (var i = 0, l = focusForms.length; i < l; i++) {
            (function (focusForm) {
                var elements = focusForm.find('input[type="text"]').first();
                elements.on('focus', function () {
                    focusForm.addClass('focused');
                });
                elements.on('blur', function () {
                    focusForm.removeClass('focused');
                    focusForm[elements.val() ? 'addClass' : "removeClass"]('filled');
                });
            })(focusForms.eq(i));
        }
    }

    function initTextarea() {
        var textarea = $('.js-textarea').not('.js-inited');
        textarea.addClass('js-inited');

        if (!textarea.length)
            return;

        var autosize = require('autosize');
        autosize(textarea);
    }

    function initSpinbox() {
        var spinboxes = $('.js-spinbox');

        if (!spinboxes.length)
            return;

        spinboxes.attr('readonly', 'true');

        require.ensure([], function () {
            var spinbox = require('spinbox');
            for (var i = 0, l = spinboxes.length; i < l; i++) {
                var el = spinboxes.eq(i);
                if (el.parent().hasClass('bootstrap-touchspin')) {
                    continue;
                }
                el.TouchSpin({
                    initval: 1,
                    min: 1,
                    max: 999,
                    buttonup_txt: '<svg class="icon-spinbox-plus"><use xlink:href="#icon-spinbox-plus"></use></svg>',
                    buttondown_txt: '<svg class="icon-spinbox-minus"><use xlink:href="#icon-spinbox-minus"></use></svg>',
                    buttondown_class: 'spinbox__btn spinbox__btn_down',
                    buttonup_class: 'spinbox__btn spinbox__btn_up',
                    mousewheel: false
                });
            }
        }, 'spinbox');

        

    }

    function loadChosen(selects) {
        require.ensure([], function () {

            var chosen = require('chosen');

            selects.chosen({
                disable_search_threshold: 50
            });

            require.ensure([], function () {
                var iscroll = require('iscroll-probe');
                for (var i = 0, l = selects.length; i < l; i++) {
                    var select = selects.eq(i),
                        selectDrop = select.next().find('.chosen-drop__inner'),
                        selectScroll;
                    selectScroll = new iscroll(selectDrop[0], {
                        probeType: 1,
                        scrollbars: 'custom',
                        interactiveScrollbars: true,
                        preventDefault: false,
                        preventDefaultOnlyTouch: true,
                        bounce: true,
                        deceleration: 0.001,
                        mouseWheel: true,
                        disableMouse: true,
                        scrollY: true,
                        click: false,
                        tap: true
                    });
                    selectScroll.on('scroll', onScroll.bind(selectDrop, selectScroll));
                    selectScroll.on('scrollend', onScroll.bind(selectDrop, selectScroll));
                    select.on('chosen:showing_dropdown', showSelect.bind(select, selectScroll, selectDrop));
                    select.on('chosen:hiding_dropdown', hideSelect.bind(select, selectScroll));
                    $(window).on('selects:resize', selectScroll.refresh(selectScroll));
                }

                $(window).on('resize:finished', resizeSelects);
    
            }, 'iscroll-probe');
            
        }, 'chosen');
    }

    function initSelects() {
        if (window.App.globals.isMobile)
            return;

        var selects = $('.js-select').not('.js-inited');
        selects.addClass('js-inited');

        if (!selects.length)
            return;

        var observerOptions = {
            root: null,
            rootMargin: '200px',
            threshold: 0.01
        }

        var callback = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    loadChosen(selects);
                    for (var i=0; i < selects.length; i++) {
                        observer.unobserve(selects[i])
                    }
                }
            })

        };

        if (isIntersectionObserverAvailable) {
            var observer = new IntersectionObserver(callback, observerOptions);
            for (var i=0; i < selects.length; i++) {
                observer.observe(selects[i])
            }

        } else {
            loadChosen(selects);
        }


    }

    function initCustomSelect() {
        var selectNodes = $('.js-custom-select').not('.js-inited');

        if ( !selectNodes.length ) {
            return false;
        }

        var selectOriginNodes = selectNodes.find('.js-select');

        if ( !selectOriginNodes.length ) {
            return false;
        }

        selectOriginNodes.on('change', updateCustomSelect);
        selectOriginNodes.trigger('change');
        selectNodes.addClass('js-inited');
    }

    function updateCustomSelect(event){
        updateDescription (event);
        updateShortLabel(event);
    }

    function updateDescription ( event ){
        var option = $(event.target).find(':selected'),
            descr = $(event.target).siblings('.js-custom-select-description'),
            currentStoragetype,
            descrText = "";

        if(!descr.length) {
            return;
        }

        if (event.storageType) {
            event.target.setAttribute('data-current-storage-type', event.storageType);
            currentStoragetype = event.storageType;
        } else {
            currentStoragetype = event.target.getAttribute('data-current-storage-type');
        }

        switch (currentStoragetype) {
            case "B":
                descrText = option.data('desc-business');
                break;
            case "D":
            case "S":
                descrText = option.data('desc-personal');
                break;
        }

        descr.text(descrText);
    }

    function updateShortLabel(event){
        var option = $(event.target).find(':selected'),
            label = $(event.target).siblings('.js-custom-select-short-label'),
            shortLabelText = "";

        if(!label.length) {
            return;
        }

        shortLabelText = option.data('short-label');

        label.text(shortLabelText);

    }

    function showSelect(selectScroll, selectDrop) {
        selectScroll.refresh();
        onScroll.call(selectDrop, selectScroll);
        $('html').on('keydown.appforms', keyWatcher.bind(this, selectScroll))
            .on('keyup.appforms', keyupWatcher.bind(this, selectScroll));
    }

    function hideSelect() {
        $('html').off('keydown.appforms')
            .off('keyup.appforms');
    }

    function onScroll(selectScroll) {
        var pos = Math.abs(selectScroll.y),
            max = Math.abs(selectScroll.maxScrollY),
            min = 0;
        this[pos <= min ? 'addClass' : 'removeClass']('topped');
        this[pos >= max ? 'addClass' : 'removeClass']('bottomed');
    }

    function keyupWatcher(selectScroll) {
        selectScroll.refresh(selectScroll);
    }

    function keyWatcher(selectScroll, e) {
        var cursor = this.next().find('.chosen-drop').find('li.highlighted');

        if (!cursor.length)
            return;
        var hei = cursor.outerHeight(),
            top = cursor[0].offsetTop - hei;

        switch (e.keyCode) {
            case 38:
                e.stopPropagation();
                e.preventDefault();
                selectScroll.scrollTo(selectScroll.x, Math.max(Math.min(0, -top), selectScroll.maxScrollY), 0);
                break;
            case 40:
                e.stopPropagation();
                e.preventDefault();
                selectScroll.scrollTo(selectScroll.x, Math.min(0, Math.max(selectScroll.maxScrollY, -top)), 0);
                break;
            case 33:
            case 34:
                e.stopPropagation();
                e.preventDefault();
                break;
            default:
                break;
        }
    }

    function refreshSelect(iscroll) {
        if (this.next().find('.chosen-drop').find('li').length) {
            iscroll.refresh();
        }
    }

    function resizeSelects() {
        $('.js-select.js-inited').trigger("chosen:updated");
        $(window).trigger('selects:resize');
    }

    function initDatePickers() {
        var datepickers = $('.js-datepicker').not('.js-inited');
        datepickers.addClass('js-inited');
        datepickers.attr('readonly', 'true');

        if (!datepickers.length)
            return;        

        var now = new Date(),
            inHalfYear = new Date(new Date().setMonth(new Date().getMonth() + 6)),
            inChooseRange = new Date(new Date().setDate(new Date().getDate() + 120)),
            defaultCulture = 'en-GB';

        var currentCulture = window.App.globals.culture || defaultCulture;
        var pikadayOptions = {
            format: 'D MMM YYYY',
            toString: function(date, format) {
                return date.toLocaleDateString(currentCulture, {year: 'numeric', month: 'long', day: 'numeric'});
            },
            minDate: now,
            maxDate: inChooseRange,
            firstDay: 1,
        };
        if (window.App.globals.i18nCalendar !== undefined) {
            pikadayOptions.i18n = window.App.globals.i18nCalendar;
        }

        require.ensure([], function () {
            var pikaday = require('pikaday');
            for (var i = 0, l = datepickers.length; i < l; i++) {
                new pikaday($.extend({},pikadayOptions, {
                    container: datepickers[i].parentNode,
                    trigger: datepickers.eq(i).parent().find('.js-datepicker-replicator')[0],
                    field: datepickers[i]
                }));
            }
        }, 'pikaday');

        



        $('.js-datepicker-replicator').off('click.prevent');
        $('.js-datepicker-replicator').on('click.prevent', function (e) {
            e.preventDefault();
        });
    }

    function initCorrespondence() {
        var correspondEls = $('.js-correspond-to').not('.js-correspond-inited');
        if (!correspondEls.length)
            return;

        correspondEls.addClass('js-correspond-inited');

        for(var i=0, l=correspondEls.length; i<l; i++) {
            var correspondEl = correspondEls.eq(i),
                selector = correspondEl.attr('data-correspond-selector'),
                prefix =correspondEl.attr('data-correspond-prefix').replace(/-([a-zA-Z])/g, function (g) { return g[1].toUpperCase(); }),
                corespondedEls = correspondEl.parents('.js-custom-form').find(selector);
            correspondEl.on('change', onCorrespondChange.bind(this, correspondEl, corespondedEls, prefix));
            onCorrespondChange(correspondEl, corespondedEls, prefix);
        }

    }

    function onCorrespondChange(correspondEl, correspondedEls, prefix) {
        var val = correspondEl.val();
        for(var i=0, l=correspondedEls.length; i<l; i++) {
            $.data(correspondedEls[i], prefix, val);
        }
    }

    function initDefault() {
        var defaultEls = $('.js-set-default-to').not('.js-default-inited');
        if (!defaultEls.length)
            return;

        defaultEls.addClass('js-default-inited');

        for(var i=0, l=defaultEls.length; i<l; i++) {
            var defaultEl = defaultEls.eq(i),
                selector = defaultEl.attr('data-default-selector'),
                defaultToEl = defaultEl.parents('.js-custom-form').find(selector);
            defaultEl.on('click', onDefaultChange.bind(defaultEl, defaultToEl));
            onDefaultChange.call(defaultEl, defaultToEl);
        }
    }

    function onDefaultChange(defaultToEl) {
        var tracked = defaultToEl.filter('.js-tracked'),
            trackDimension = defaultToEl.filter('.js-track-dimension');
        defaultToEl.find('[data-default="' + this.val() + '"]').prop('selected', 'selected');
        defaultToEl.trigger('chosen:updated');

        tracked.removeClass('.js-tracked');
        trackDimension.removeClass('.js-track-dimension');

        defaultToEl.trigger({
            type: 'change',
            storageType: this.val()
        });

        tracked.addClass('.js-tracked');
        trackDimension.addClass('.js-track-dimension');
    }

    function initSimpleForms() {
        var forms = $('.js-simple-form').not('.js-inited');
        if (!forms.length)
            return;

        for (var i = 0, l = forms.length; i <= l; i++) {
            var form = forms.eq(i);
            form.addClass('js-inited');
            initSimpleForm(form);

        }

    }

    function initSimpleForm(form) {
        var submitBtn = form.find('.js-submit-btn');
        var searchBtn = form.find('.js-search-btn');
        var inputSubmit = form.find('.js-input-submit');

        additionalTracking(form);

        submitBtn.off('click.form-module');
        searchBtn.off('click.form-module');
        inputSubmit.on('focus', inputSubmitFocus.bind(submitBtn, form, null));
        inputSubmit.on('blur', inputSubmitBlur);
        submitBtn.on('click.form-module', successSubmitProcess.bind(submitBtn, form));
        searchBtn.on('click.form-module', submitFindAddress.bind(searchBtn, form));
    }

    function initCustomForms() {
        var forms = $('.js-custom-form');
        if (!forms.length)
            return;

        var observerOptions = {
            root: null,
            rootMargin: '200px',
            threshold: 0.01
        }

        var callback = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    loadParsley(forms);
                    for (var i=0; i < forms.length; i++) {
                        observer.unobserve(forms[i])
                    }
                }
            })

        };

        if (isIntersectionObserverAvailable) {
            var observer = new IntersectionObserver(callback, observerOptions);
            for (var i=0; i < forms.length; i++) {
                observer.observe(forms[i])
            }

        } else {
            loadParsley(forms);
        }

        for (var i = 0; i < forms.length; i++) {
          var formLoader = $(forms[i]).data('use-loader');
          if (formLoader !== undefined) {
            initLoader(forms[i]);
          }
        }
    }

    function initLoader(formToInit) {
      var form = $(formToInit);
      var loaderText = form.data('use-loader');
      var loaderContainer = document.createElement('div');
      loaderContainer.classList.add('custom-form__loader');
      var loaderBox = document.createElement('div');
      loaderBox.classList.add('custom-form__loader-box');
      if (loaderText.length > 0 ){
        var loaderTextContainer = document.createElement('p');
        loaderTextContainer.classList.add('custom-form__loader-text');
        loaderTextContainer.innerText = loaderText;
        loaderBox.appendChild(loaderTextContainer);
      }
      loaderContainer.appendChild(loaderBox);
      form.parents('.container').append(loaderContainer);
      form.addClass('js-has-loader');
    }

    function loadParsley(forms) {
        require.ensure([], function () {
            var parsley = require('parsley');

            initParsleyConfig();
            initAllFormValidation(forms);

        }, 'parsley');

    }

    function initParsleyConfig() {
        if (isParsleyInited)
            return;
        isParsleyInited = true;

//        window.ParsleyValidator
//            .addValidator('payment', function (value, requirement) {
//                var paymentMatch = value.match(/^[0-9]*(\.[0-9]{1,2})?$/g);
//                return (paymentMatch && paymentMatch.length == 1 && paymentMatch[0] == value) == requirement;
//            })
//            .addMessage('en', 'payment', 'Please enter a valid payment amount');
    }

    function initAllFormValidation(forms) {
        forms = forms.not('.js-inited');
        for (var i = 0, l = forms.length; i <= l; i++) {
            var form = forms.eq(i);
            form.addClass('js-inited');
            initSingleFormValidation(form);
        }
    }

    function initSingleFormValidation(form) {
        var elements = form.find('input, select, textarea').not('[type="hidden"], [type="submit"]'),
            phone = form.find('.js-phone'),
            submitBtn = form.find('.js-submit-btn'),
            searchBtn = form.find('.js-search-btn'),
            formUnrequiredChbx = form.find('.js-form-unrequired input[type="checkbox"]'),
            inputSubmit = form.find('.js-input-submit'),
            prsyElements = [];

            elements.each(function(){
                if($(this).length) {
                    prsyElements.push($(this).parsley({
                        successClass: "is-success",
                        errorClass: "is-error",
                        errorsWrapper: "<ul class='errors-list'></ul>",
                        classHandler: parentFind,
                        errorsContainer: parentFind
                    }));
                }
            });

        if(inputSubmit.parents(".nav_side").length) {
            var placeholderInterLang = inputSubmit.data('placeholder');
            inputSubmit.attr("placeholder", placeholderInterLang);
        }

        for (var i = 0, l = elements.length; i < l; i++) {
            var el = elements.eq(i),
                prsyElement = prsyElements[i];
            el.on('change parsleyupdate', checkprsy.bind(prsyElement));
            if (el.val() !== "" && !el.is('[type="checkbox"]')) {
                el.trigger("parsleyupdate");
            }
            if (!el.is('select'))
                el.on('change.firsttime', checkprsyfirst.bind(prsyElement));
        }

        if (phone.length) {
            phone.on('keypress', phoneKeyDown);
            phone.on('input change', phoneInput);
        }

        if (formUnrequiredChbx.length) {
            formUnrequiredChbx.on('change', formUnrequiredInit);
            formUnrequiredInit.call(formUnrequiredChbx);
        }

        additionalTracking(form);

        submitBtn.off('click.form-module');
        searchBtn.off('click.form-module');
        inputSubmit.on('focus', inputSubmitFocus.bind(submitBtn, form, prsyElements));
        inputSubmit.on('blur', inputSubmitBlur);
        submitBtn.on('click.form-module', submitProcess.bind(submitBtn, form, prsyElements));
        searchBtn.on('click.form-module', submitFindAddress.bind(searchBtn, form, prsyElements));
    }

    function formUnrequiredInit() {
        var control = $(this),
            isChecked = control.is(":checked"),
            subForm = control.parents('.js-custom-subform'),
            subFormControls = subForm.find('input, select, textarea').not(control);

        if (isChecked) {
            subForm.trigger('dropdown:close');
            subFormControls.attr('disabled', 'disabled');
        } else {
            subForm.trigger('dropdown:open');
            subFormControls.removeAttr('disabled');
        }

    }

    function inputSubmitFocus(form, prsyElements, e) {
        $(e.target).on('keypress.customform', inputSubmitKeypress.bind(this, form, prsyElements));
    }

    function inputSubmitBlur(e) {
        $(e.target).off('keypress.customform');
    }

    function inputSubmitKeypress(form, prsyElements, e) {
        if (e.which == 13) {
            submitProcess.call(this, form, prsyElements, e);
        }
    }

    function parentFind(field) {
        var parent = null;
        if (field.$element.is('input[type="checkbox"]'))
            parent = field.$element.parents('.custom-form__row_checkbox');
        if (parent == null || !parent.length)
            parent = field.$element.parent();
        return parent;
    }

    function checkprsyfirst() {
        this.$element.off('change.firsttime');
        this.$element.on('blur keyup', checkprsy.bind(this));

    }

    function checkprsy() {
        parentFind(this)[this.$element.val() != "" ? "addClass" : "removeClass"]("filled");
        return this.validate() === true;
    }

    function phoneKeyDown(e) {
        var key = e.which;
        if (key === 0 || key === 8 || e.ctrlKey || e.altKey)
            return;
        if (!/[0-9\s\+]/.test(String.fromCharCode(e.which)))
            return false;
    }

    function phoneInput(e) {
        var $this = $(this),
            val = $this.val(),
            newval = val.replace(/[^0-9\s\+]/g, '');
        if (newval !== val) {
            $this.val(newval);
            $this.trigger('change');
        }
    }

    function customSerialize(form) {
        var elements = form.find('input, select, textarea'),
            serialize = '',
            captcha = form.find('#g-recaptcha-response');
        for (var i = 0, l = elements.length; i < l; i++) {
            var element = elements.eq(i),
                name = element.attr('data-name'),
                val = element.is(':checkbox') ? (element.is(":checked") ? element.val() : "") : element.val();
            if (!name) continue;
            if(serialize.length)
                serialize += '&';
            if(element.hasClass('js-datepicker')) {

                require.ensure([], function () {
                    var moment = require('moment');
                    val = moment(val, 'D MMM YYYY').format('YYYY/MM/DD ');        
                }, 'moment');
            }

            serialize += name + '=' + encodeURIComponent(val);
        }
        if (captcha.length) {
            if (serialize.length)
                serialize += '&';
            serialize += encodeURIComponent(captcha.attr('name')) + '=' + encodeURIComponent(captcha.val());
        }
        return serialize;
    }

    function ajaxSubmitForm(form) {
        var serialize = customSerialize(form),
            href = form.attr('data-href');

        form.trigger('forms:submitQuote', [href, serialize]);
    }

    function ajaxSubmitAndRedirectTo(e, href, queryString) {
        var control = $(e.target);
        var dataAttributes = control.data(),
            starting = 'enquiry';

        if (!href)
            return;

        for (var attr in dataAttributes) {
            if (attr.indexOf(starting) == 0)
                queryString += '&' + attr.substr(starting.length).toLowerCase() + '=' + encodeURIComponent(dataAttributes[attr]);
        }

        let clientId = undefined;
        let gtmCookieClientId = window.dataLayer.find(obj => obj.safestoreBE_cookieClientId !== undefined);

        if (gtmCookieClientId) {
            clientId = gtmCookieClientId.safestoreBE_cookieClientId;
        }

        if (clientId) {
            queryString += '&gcid=' + clientId;
        }

        $.ajax({
            method: "POST",
            url: href,
            contentType: 'application/x-www-form-urlencoded',
            dataType: "json",
            data: queryString,
            success: function (data) {
                if (data.status == "ok") {
                    window.location.href = (data.url);
                } else {
                    control.removeClass('js-disabled');
                    control.parents('.js-popup-container').trigger('popup:error', data.message || "");
                }
            },
            error: function (data) {
                control.removeClass('js-disabled');
                control.parents('.js-popup-container').trigger('popup:error', data.message || "");
            }
        });
    }

    function submitProcess(form, prsyElements, e) {
        if (form.hasClass('js-disabled') || !form.is(':visible')) {
            e.preventDefault();
            //e.stopPropagation();
            return;
        }

        var valid = true,
            findAddressContent = $('.js-find-address-form-content');

        if (prsyElements !== null && typeof prsyElements.length != 'undefined' && prsyElements.length) {
            for (var i = 0, l = prsyElements.length; i < l; i++) {
                valid = (prsyElements[i].$element.is(":disabled") || checkprsy.call(prsyElements[i])) && valid;
            }
        } else if (prsyElements !== null) {
            valid = checkprsy.call(prsyElements) && valid;
        }


        if (!valid) {
            e.preventDefault();
            initFindAddress(true);
            expandDropdowns(form);

            var iserror = form.find('.is-error').first();
            if (iserror.length) {
                var top = window.App.globals.getTop(),
                    offsetTop = iserror.offset().top + (window.App.globals.isCustomScroll ? top : 0);
                if (top > offsetTop + iserror.outerHeight())
                    window.App.globals.scrollElement.stop().animate({ 'scrollTop': offsetTop }, 500);
            }

            this.removeAttr('disabled');
            //e.stopPropagation();
            return;
        }
        successSubmitProcess.call(this, form, e);

    }

    function successSubmitProcess(form, e) {
        form.trigger('beforesubmit');
        additionalTracking(form);
        form.addClass('js-disabled');
        form.trigger('gatrack:send');

        if (form.hasClass('js-has-loader')) {
          var loader = $('.custom-form__loader');
          loader.addClass('loading');
        }

        if (form.hasClass('js-ajax-submit')) {
            e.preventDefault();
            ajaxSubmitForm(form);
        } else if (form.hasClass('js-duplicate-submit')) {
            e.preventDefault();
            $('.js-submit-btn-duplicate').click();
        } else {
            __doPostBack(this.attr('data-clientid'), '');
        }
    }

    function expandDropdowns(form) {
        if (form.data('expandDropdowns') === undefined) {
            return;
        }
        var dropdownSelector = '.js-dropdown, .js-enquiry-form-dropdown';
        var dropdown = form.find(dropdownSelector).not('.opened').has('.is-error').first();

        if (dropdown.length && dropdown[0].instance !== undefined && typeof dropdown[0].instance.open === 'function') {
            var dropdownInstance = dropdown[0].instance;
            dropdownInstance.open();
        }
    }

    function additionalTracking(form) {
        if (!form.hasClass('js-add-additional-tracking'))
            return;

        if(form.hasClass('js-add-additional-multilabel')) {
            addAdditionalMultiLabel(form);
        }

        if (form.hasClass('js-add-additional-label')) {
            addAdditional(form, 'data-tracking-old-label', 'data-tracking-label');
        }

        if(form.hasClass('js-add-additional-action')) {
            addAdditional(form, 'data-tracking-old-action', 'data-tracking-action');
        }
    }

    function addAdditionalMultiLabel(form) {
        var additionalEls = form.find('.js-additional-tracking').not('.tt-hint'),
            label = '';
        for(var i=0, l=additionalEls.length; i<l; i++) {
            var element = additionalEls[i],
                $element = $(element);
            label += label.length ? ' > ' : '';
            label += $element.is('select') ? element.options[element.selectedIndex].innerHTML : $element.val()
        }
        form.attr('data-tracking-label', label);
    }

    function addAdditional(form, oldLabelName, newLabelName) {
        var oldLabel = form.attr(oldLabelName),
            label = form.attr(newLabelName),
            track = form.find('.js-additional-tracking').not('.tt-hint').first();
        if (typeof label == 'undefined' || !track.length)
            return;

        if (typeof oldLabel == 'undefined') {
            form.attr(oldLabelName, label);
            oldLabel = label;
        }

        var value = track.is('select') ? track[0].options[track[0].selectedIndex].innerHTML : track.val();
        form.attr(newLabelName, oldLabel + value);
    }

    function submitFindAddress(form, prsyElements, e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.hasClass('js-disabled')) {
            return;
        }

        var input = $('.js-search-input');

        this.trigger('gatrack:send');
    }

    function initFindAddress(toExpandAll) {
        var toExpandAll = toExpandAll || false,
            findAddress = $('.find-address-form__dropdown'),
            findAddressLink = toExpandAll ? findAddress.find('.js-form-select-expander') : findAddress.find('.js-form-expander');

        if (!findAddress.hasClass('opened')) {
            findAddressLink.click();
        }
    }

    window.expandFindAddress = initFindAddress;


    window.updateSelect = function() {
        initSelects();
    }

    window.updateForm = function() {
        $(".js-custom-form").removeClass('js-inited');
        $(".js-search-btn").removeClass('js-tracking-done');
        initCustomForms();
    }

    return {
        init: init
    };

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.forms.js
 ** module id = 41
 ** module chunks = 24
 **/